import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getInitialNodes,
  setLanguageCode
} from '../scriptbot_flow/scriptbotflow-slice';
import {
  addNode,
  deleteNode,
  deleteNodes,
  initializeFlow
} from '../flow/flow-slice';
import { BlazeoApi } from '../integration';
import store from 'store';

const blazeoApi = new BlazeoApi();

export const loadAgentScriptAnswers = createAsyncThunk(
  'agentScritpAnswers/getAll',
  async args => {
    const { companyId, nodes } = args;

    if (isNaN(+companyId)) {
      throw 'Error';
    }

    const allQuestions = [];
    const nodeIds = nodes.map(node => node.id);

    let agentScript = (await blazeoApi.getAgentScript(companyId, 'enb')).data
      .data;
    let selectedLang = 'enb';
    if (!agentScript?.id) {
      agentScript = (await blazeoApi.getAgentScript(companyId, 'eng')).data
        .data;
    selectedLang = 'eng';
    }

    store.dispatch(setLanguageCode(selectedLang));
    agentScript.questions.forEach(question => {
      question.answers.forEach(answer => {
        if (nodeIds.includes(answer.id.toString())) {
          answer.inFlow = true;
        } else {
          answer.inFlow = false;
        }
        allQuestions.push(answer);
      });
    });

    return {
      allQuestions: allQuestions
    };
  }
);

const initialState = {
  all: []
};

export const agentScriptAnswersSlice = createSlice({
  name: 'agentScriptAnswers',
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getInitialNodes.fulfilled, (state, action) => {
        const allQuestions = [];

        action.payload.allQuestions.forEach(question => {
          const questionCopy = JSON.parse(JSON.stringify(question));
          if (action.payload.usedQuestions.includes(question)) {
            questionCopy.inFlow = true;
          } else {
            questionCopy.inFlow = false;
          }
          allQuestions.push(questionCopy);
        });

        state.all = allQuestions;
      })
      .addCase(loadAgentScriptAnswers.fulfilled, (state, action) => {
        state.all = action.payload.allQuestions;
      })
      .addCase(addNode, (state, action) => {
        const allQuestions = [];
        state.all.forEach(question => {
          if (question.id == action.payload.data.question.id) {
            question.inFlow = true;
          }
          allQuestions.push(question);
        });
        state.all = allQuestions;
      })
      .addCase(deleteNode, (state, action) => {
        const allQuestions = [];
        state.all.forEach(question => {
          if (question.id == action.payload.data.question.id) {
            question.inFlow = false;
          }
          allQuestions.push(question);
        });
        state.all = allQuestions;
      })
      .addCase(deleteNodes, (state, action) => {
        const allQuestions = [];
        state.all.forEach(question => {
          action.payload.forEach(deletingNodes => {
            if (question.id == deletingNodes.data.question.id) {
              question.inFlow = false;
            }
          });
          allQuestions.push(question);
        });
        state.all = allQuestions;
      })
      .addCase(initializeFlow, (state, action) => {
        const allQuestions = [];
        state.all.forEach(question => {
          question.inFlow = false;
          allQuestions.push(question);
        });
        state.all = allQuestions;
      });
  }
});

export const { updateQuestionTree } = agentScriptAnswersSlice.actions;
export default agentScriptAnswersSlice.reducer;
